import React from 'react';
import PropTypes from 'prop-types';
import {TrayType} from 'constants/dataEnum';

import NestCard from './NestCard';
import './NestContent.scss';

function NestContent({trayType, invalidNestIds, isSolving, solvingNestId}) {
  const nestStates = {
    nest1: {
      nest: 1,
      type: trayType === TrayType.DOUBLE_CADDY ? 'tip-caddy-rounded' : 'plate',
    },
    nest2: {nest: 2, type: trayType === TrayType.HIGH_VOLUME_CADDY ? 'tip-caddy-high-volume' : 'tip-caddy-rounded'},
    nest3: {nest: 3, type: 'plate'},
    nest4: {nest: 4, type: 'plate'},
    nest5: {nest: 5, type: 'plate'},
    nest6: {nest: 6, type: 'plate'},
  };

  const renderNest = (nestKey) => {
    const {nest, type} = nestStates[nestKey];
    const isInvalid = invalidNestIds.includes(nest);

    if (type !== 'plate') {
      return (
        <div className="nest caddy">
          <img src={`./svg/protocol-editor/${type}.svg`} alt="Caddy" width={97} height={133} />
        </div>
      );
    }

    return <NestCard nestNumber={nest} isInvalid={isInvalid} isSolving={isSolving} solvingNestId={solvingNestId} />;
  };

  return (
    <div className="modal-nests-container">{Object.entries(nestStates).map(([nestKey]) => renderNest(nestKey))}</div>
  );
}

NestContent.propTypes = {
  trayType: PropTypes.any.isRequired,
  invalidNestIds: PropTypes.any.isRequired,
  isSolving: PropTypes.bool.isRequired,
  solvingNestId: PropTypes.number,
};

NestContent.defaultProps = {
  solvingNestId: null,
};

export default NestContent;
